import React, { useState } from "react";
import { useFormik } from "formik";
import { Link, useHistory, useParams } from "react-router-dom";
import { CommonUrl } from "../../../common-url/CommonUrl";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import * as Yup from "yup";

export default function ResetPassword() {
  const history = useHistory();
  const [snackMsg, setSnackMsg] = useState({});
  const [openSnack, setOpenSnack] = useState(false);

  const initialValues = {
    password: ""
  };

  let { id } = useParams();

  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string().min(6,"Too short").required("Required*"),
    rePassword: Yup.string()
      .required("Required*")
      .oneOf([Yup.ref("password"), null], "Passwords must match")
  });

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      fetch(CommonUrl.resetPaswordBaseUrl + `/reset-password/${id}`, {
        method: "put",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          vPassword: values.password
        })
      })
        .then(response => response.json())
        .then(response => {
          if (response.code == 200) {
            setSnackMsg(response);
            open();
            setTimeout(() => {
              history.push("/auth/login");
            }, 2000);
          } else {
            setSnackMsg(response);
            open();
            setSubmitting(false);
          }
        });
    }
  });

  const open = () => {
    setOpenSnack(true);
  };

  const close = () => {
    setOpenSnack(false);
  };
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        open={openSnack}
        autoHideDuration={2000}
        onClose={close}
      >
        <Alert
          onClose={close}
          severity={snackMsg.code == 200 ? "success" : "error"}
        >
          {snackMsg.message}
        </Alert>
      </Snackbar>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-5 mb-lg-10">
          <h3 className="font-size-h1">Reset Password</h3>
        </div>
        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          autocomplete="off"
        >
          {formik.status && (
            <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
              <div className="alert-text font-weight-bold">{formik.status}</div>
            </div>
          )}
          <div className="form-group fv-plugins-icon-container">
            <input
              type="password"
              placeholder="Your New Password"
              className={`form-control form-control-solid h-auto py-5 px-6`}
              name="password"
              {...formik.getFieldProps("password")}
            />
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group fv-plugins-icon-container">
            <input
              type="password"
              placeholder="Re-enter Your New Password"
              className={`form-control form-control-solid h-auto py-5 px-6`}
              name="rePassword"
              {...formik.getFieldProps("rePassword")}
            />
            {formik.errors.rePassword ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.rePassword}</div>
              </div>
            ) : null}
          </div>
          <div className="form-group d-flex flex-wrap flex-center">
            <button
              id="kt_login_forgot_submit"
              type="submit"
              className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
              disabled={formik.isSubmitting}
            >
              Submit
            </button>
            <Link to="/auth">
              <button
                type="button"
                id="kt_login_forgot_cancel"
                className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
              >
                Cancel
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
